/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
Swiper.use([Navigation, Pagination, Autoplay]);
export function slider() {
    const cardsSliderSelector = ".cards__inner.swiper";
    const eventsSliderSelector = ".events-list__inner.swiper";
    const imageSliderSelector = ".image-slider__inner.swiper";
    const contentBoxesSliderSelector = ".content-boxes.swiper";
    const openingHoursSliderSelector = ".opening-hours.swiper";
    const packagesSliderSelector = ".packages__inner";

    const breakpoint = 768;

    //Fix the tabindex for accebility if the content of the slide is wrapped in an anchor tag
    const handleSlideChangeTransitionEnd = function (swiper) {
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
    const handleSlideChange = function () {
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const escapeHtml = (text) => text.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

    const init = function () {

        // Cards slider
        const cardsSlider = [];
        const cardsSliderElements = document.querySelectorAll(cardsSliderSelector);
        if (cardsSliderElements) {
            cardsSliderElements.forEach(slider => {
                cardsSlider.push(new Swiper(slider, {
                    slidesPerView: 1.3,
                    spaceBetween: 10,
                    speed: 600,
                    loop: true,
                    centeredSlides: true,
                    breakpoints: {
                        992: {
                            spaceBetween: 30,
                            slidesPerView: 4.1,
                            centeredSlides: false,
                            loopAddBlankSlides: true,
                        },
                        768: {
                            spaceBetween: 30,
                            slidesPerView: 2.5,
                            centeredSlides: false
                        }
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .cards__button-next",
                        prevEl: '#' + slider.dataset.componentId + " .cards__button-prev",
                    },
                    on: {
                        init: function () {
                            const slideElements = this.el.querySelectorAll('.swiper-wrapper > .swiper-slide');

                            slideElements.forEach((slide, index) => {
                                const parity = (index % 2 === 0) ? 'odd-position' : 'even-position';

                                slide.setAttribute('data-parity', parity);
                            });
                        },
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Events slider
        const eventsSlider = [];
        const eventsSliderElements = document.querySelectorAll(eventsSliderSelector);
        if (eventsSliderElements) {
            eventsSliderElements.forEach(slider => {
                eventsSlider.push(new Swiper(slider, {
                    slidesPerView: 1.3,
                    spaceBetween: 10,
                    speed: 600,
                    loop: true,
                    breakpoints: {
                        992: {
                            spaceBetween: 30,
                            slidesPerView: 3.5,
                            centeredSlides: false,
                            loopAddBlankSlides: true,
                        },
                        768: {
                            spaceBetween: 30,
                            slidesPerView: 2.5,
                            centeredSlides: false
                        }
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .events-list__button-next",
                        prevEl: '#' + slider.dataset.componentId + " .events-list__button-prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Image Slider
        const imageSlider = [];
        const imageSliderElements = document.querySelectorAll(imageSliderSelector);
        if (imageSliderElements) {
            imageSliderElements.forEach(slider => {
                imageSlider.push(new Swiper(slider, {
                    slidesPerView: 1.2,
                    spaceBetween: 8,
                    speed: 600,
                    loop: true,
                    centeredSlides: true,
                    breakpoints: {
                        768: {
                            spaceBetween: 30,
                            slidesPerView: 3.3,
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Content Boxes Slider
        const contentBoxesSlider = [];
        const contentBoxesSliderElements = document.querySelectorAll(contentBoxesSliderSelector);
        if (window.innerWidth < breakpoint) {
            if (contentBoxesSliderElements) {
                contentBoxesSliderElements.forEach(slider => {
                    contentBoxesSlider.push(new Swiper(slider, {
                        slidesPerView: 1,
                        spaceBetween: 30,
                        pagination: {
                            el: '#' + slider.dataset.componentId + " .swiper-pagination",
                        },
                        on: {
                            slideChange: () => {
                                handleSlideChange();
                            },
                            slideChangeTransitionEnd: (swiper) => {
                                handleSlideChangeTransitionEnd(swiper);
                            }
                        }
                    }));
                })
            }
        }

        // Opening Hours Banner Slider
        const openingHoursSlider = [];
        const openingHoursSliderElements = document.querySelectorAll(openingHoursSliderSelector);
        if (openingHoursSliderElements) {
            openingHoursSliderElements.forEach(slider => {
                openingHoursSlider.push(new Swiper(slider, {
                    speed: 5000,
                    slidesPerView: 'auto',
                    // spaceBetween: 30,
                    allowTouchMove: false,
                    freeMode: true,
                    loop: true,
                    autoplay: {
                        delay: 0.1,
                        disableOnInteraction: false,
                        stopOnLastSlide: false
                    },
                    breakpoints: {
                        768: {
                            // spaceBetween: 30,
                            slidesPerView: 'auto',
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Packages slider
        document.querySelectorAll(packagesSliderSelector).forEach(component => {
            const slider = component.querySelector(".packages__slider");
            if (slider == null) {
                return;
            }
            const titles = Array.from(slider.querySelectorAll(".package__title")).map(title => escapeHtml(title.textContent.trim()));
            const toggleFade = (swiper) => slider.classList.toggle("packages__slider--end", swiper.isEnd || swiper.isLocked);

            new Swiper(slider, {
                slidesPerView: 1.15,
                spaceBetween: 10,
                speed: 600,
                breakpoints: {
                    992: {
                        slidesPerView: 3.4,
                        spaceBetween: 10
                    },
                    768: {
                        slidesPerView: 2.3,
                        spaceBetween: 10
                    }
                },
                navigation: {
                    nextEl: component.querySelector(".packages__button-next"),
                    prevEl: component.querySelector(".packages__button-prev"),
                },
                pagination: {
                    el: component.querySelector(".packages__pagination"),
                    clickable: true,
                    renderBullet: (index, className) => `<button type="button" class="${className}">${titles[index]}</button>`
                },
                on: {
                    afterInit: toggleFade,
                    slideChange: toggleFade,
                    resize: toggleFade,
                    slideChangeTransitionEnd: (swiper) => {
                        handleSlideChangeTransitionEnd(swiper);
                    }
                }
            });
        });

    };

    init();
}
